import i18n from "i18next";
import { z } from "zod";
import { notificationSchema } from "../utils";

const LANG_BASE = "vessel-call.port-services.fields";

const approveByOperationsDebunkeringFieldsSchema = z.object({
  notes: z
    .string()
    .max(
      1000,
      i18n.t("form-validation.max-length", {
        label: i18n.t(`${LANG_BASE}.notes`),
        max: 1000,
      }),
    )
    .optional(),
  attachment: z
    .object({
      documentUrl: z.string().optional(),
      documentName: z.string().optional(),
      fileType: z.string().optional(),
    })
    .optional(),
});

export const approveByOperationsDebunkeringSchema = () =>
  approveByOperationsDebunkeringFieldsSchema.merge(notificationSchema);

export type ApproveByOperationsDebunkeringSchema = z.infer<
  ReturnType<typeof approveByOperationsDebunkeringSchema>
>;
